import { useAuth } from "@/features/Auth";
import { clearSentryUser } from "@/features/Sentry/utils";
import { Button, ButtonGroup, DropdownItem, DropdownMenu } from "@heroui/react";
import { FaSignOutAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";

type UserMenuProps = {
  onClose?: () => void;
};

const UserMenu = ({ onClose }: UserMenuProps) => {
  const { resetUser } = useAuth();
  const { t, i18n } = useTranslation();
  const hrefLogout = `${import.meta.env.VITE_BACKEND_URL}/sso/cognito/logout`;
  const language = i18n.language?.startsWith("fr") ? "fr" : "en";

  return (
    <DropdownMenu aria-label="User menu" closeOnSelect={false}>
      <DropdownItem
        key="language"
        textValue={t("language.label")}
        className="cursor-default bg-transparent data-[hover=true]:bg-transparent data-[focus=true]:bg-transparent"
      >
        <div className="px-1 pb-2 text-[11px] font-semibold uppercase tracking-wide text-foreground-500">
          {t("language.label")}
        </div>
        <ButtonGroup
          radius="full"
          size="sm"
          className="w-full rounded-full bg-content1 p-0.5 border border-divider shadow-sm"
        >
          {(["fr", "en"] as const).map((lng) => {
            const isActive = language === lng;
            return (
              <Button
                key={lng}
                variant={isActive ? "solid" : "light"}
                color={isActive ? "primary" : "default"}
                className="w-1/2 text-xs"
                onPress={() => {
                  if (!isActive) void i18n.changeLanguage(lng);
                }}
              >
                {lng.toUpperCase()}
              </Button>
            );
          })}
        </ButtonGroup>
      </DropdownItem>
      <DropdownItem
        key="logout"
        textValue={t("actions.logout")}
        startContent={<FaSignOutAlt />}
        className="text-foreground data-[hover=true]:bg-content2"
        onPress={() => {
          clearSentryUser();
          resetUser();
          localStorage.removeItem("redirectAfterLogin");
          onClose?.();
          window.location.href = hrefLogout;
        }}
      >
        {t("actions.logout")}
      </DropdownItem>
    </DropdownMenu>
  );
};

export default UserMenu;
